import { CREDIT_CARD, SAMSUNG_PAY, GOOGLE_PAY } from './paymentMethodTypes';

import creditCardImage from './images/credit-card.inline.svg';
import googlePayImage from './images/google-pay.inline.svg';
import samsungPayImage from './images/samsung-pay.inline.svg';

export const paymentImageList = [
    {
        type: CREDIT_CARD,
        url: creditCardImage,
        alt: CREDIT_CARD
    },
    {
        type: GOOGLE_PAY,
        url: googlePayImage,
        alt: GOOGLE_PAY
    },
    {
        type: SAMSUNG_PAY,
        url: samsungPayImage,
        alt: SAMSUNG_PAY
    },
];
